import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    forwardRef,
    Input,
    Output,
    ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'a-input',
    templateUrl: './a-input.component.html',
    styleUrls: ['./a-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AInputComponent),
            multi: true
        }
    ],
    standalone: false
})
export class AInputComponent implements ControlValueAccessor, AfterViewInit {

    @Input()
    public inputType: string = 'text';

    @Input()
    public label: string;

    @Input()
    public placeholder: string = '';

    @Input()
    public required: boolean;

    @Input()
    public disabled: boolean;

    public hasIcon: boolean;

    @Input()
    public delete: boolean;

    @Input()
    public search: boolean;

    public data: string;

    private onNgChange: (value: string) => void;
    private onNgTouched: () => void;

    @Output()
    public deleted: EventEmitter<void> = new EventEmitter<void>();

    @ViewChild("input") inputField: ElementRef;
    @Input() public focus: boolean = false;

    ngAfterViewInit() {
        if (this.focus) {
            this.inputField.nativeElement.focus();
        }
    }

    constructor() {
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    registerOnChange(fn: any): void {
        this.onNgChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onNgTouched = fn;
    }

    writeValue(obj: string): void {
        this.data = obj;
    }

    public onChange(data: string): void {
        this.data = data;
        this.onNgChange(data);
    }

    public onDelete(): void {
        this.deleted.emit();
    }
}
